const LOGIN_BUTTON_CLASS_NAME = process.env.LOGIN_BUTTON_CLASS_NAME || 'can-pass-login-button';

const CAN_PASS_SIGN_TX_URL = 'https://can-pass.canfoundation.io/sign-transaction';

const CAN_KEYS_ENDPOINT = 'https://prod.api.cryptobadge.app/can-keys/graphql';

const CB_WEB = 'https://cryptobadge.app';

export {
  CAN_KEYS_ENDPOINT,
  CAN_PASS_SIGN_TX_URL,
  LOGIN_BUTTON_CLASS_NAME,
  CB_WEB,
};
